module.exports = __webpack_public_path__ + "img/sbg2.28353a46.jpg";